import {lazy} from 'react';
import GenericFallbackSuspense from '../../ui/GenericFallback/GenericFallbackSuspense';

const CollectionNewCollectionPoint = lazy(() => import('./CollectionNewCollectionPoint'/* webpackChunkName: 'CollectionNewCollectionPoint' */));

export default function CollectionNewCollectionPointLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <CollectionNewCollectionPoint />
    </GenericFallbackSuspense>
  );
}
